<sirius-grid>
  <div class="sir-container">
    <div class="sir-media">
      @switch (mediaItem.type) {
        @case ('image') {
          <sirius-image-item
            [image]="mediaItem | cast"
            [imageData]="imageData"
            [autocrop]="true"
            [roundedCorners]="true"
            data-cy="media-image">
          </sirius-image-item>
        }
        @case ('video') {
          <sirius-video-item
            #video
            [video]="mediaItem | cast"
            (click)="$event.preventDefault(); $event.stopPropagation()"
            [roundedCorners]="true"
            data-cy="media-video">
          </sirius-video-item>
        }
      }
    </div>
    @if (showDescription) {
      <span
        class="sir-description sir-text-style-paragraph-m-default"
        data-cy="media-description"
        >{{ mediaItem.title }}</span
      >
    }
  </div>
</sirius-grid>
